import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  to?: string;
  linkLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  to,
  linkLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-400 mb-2 tracking-wide">
            <i className="ri-video-line" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading font-extrabold text-xl md:text-2xl text-foreground-950">
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500 max-w-2xl">{subtitle}</p>}
      </div>
      {to && (
        <Link
          to={to}
          className="hidden sm:inline-flex items-center gap-1 px-3 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-400 hover:bg-background-200/60 transition-colors whitespace-nowrap shrink-0"
        >
          {linkLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}